module.exports = __webpack_public_path__ + "static/media/5f60c73f5e491.e0b69957.jpg";